import { ApiPaths } from '@/util/paths'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import axios from 'axios'
import { QueryKeys } from './queryKeys.ts'

const queriesToInvalidate = [{ queryKey: [QueryKeys.USER] }, { queryKey: [QueryKeys.CONFIG] }, { queryKey: [QueryKeys.WHO_AM_I] }]

export function useTokenRefresh(onSuccess?: () => void) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: () => axios.post<void>(ApiPaths.REFRESH),
    onSuccess: async () => {
      for (const queryKey of queriesToInvalidate) {
        await queryClient.invalidateQueries(queryKey)
      }

      if (onSuccess) {
        onSuccess()
      }
    }
  })
}
